export function validateOrigin(origin) {
  var _URL = new URL(origin),
      hostname = _URL.hostname;

  return hostname.endsWith('.cian.ru');
}